import { useQuery } from "@tanstack/react-query";
import axios from "./axios";

export interface DashboardStats {
  total_users: number;
  btob_users: number;
  btoc_users: number;
  btob_percent: number;
  btoc_percent: number;
  total_vehicles: number;
  fleet_clients: number;
  partners: number;
  fleet_evolution: { month: string; total: number }[];
  partner_evolution: { month: string; total: number }[];
}

export const useDashboardStats = () => {
  const { data, error, ...res } = useQuery({
    queryKey: ["admin", "dashboard", "stats"],
    queryFn: async (): Promise<DashboardStats> => {
      const response = await axios.get("/admin/dashboard/stats");
      return response.data;
    },
    staleTime: 60000,
  });
  return { stats: data, error, ...res };
};
